export default __webpack_public_path__ + "static/media/01_A.761bf3af.png";